const state = {
  viewPostCode: null,
  viewPostTpCode: null,
  isDraft: null,
  oldKeyword:null,
  oldStartTm:null,
  oldEndTm:null,
  oldPageSize:null,
  oldPageNum:null

}

const mutations = {
  saveFindParam(state, obj){
    state.oldKeyword = obj.keyword
    state.oldStartTm = obj.startTm
    state.oldEndTm = obj.endTm
    state.oldPageSize = obj.pageSize
    state.oldPageNum = obj.pageNum
  },
  findCaseShareDetail(state, obj){
    state.viewPostCode = obj.postCode
    state.viewPostTpCode = obj.postTpCode
    state.isDraft = obj.isDraft
  },
  clearFindParam(state){
    state.oldKeyword = null;
    state.oldStartTm = null;
    state.oldEndTm = null;
    state.oldPageSize = null;
    state.oldPageNum = null;
  },
  clearViewPostCode(state){
    state.viewPostCode = null;
  }
}

const actions = {
  saveFindParam:({commit, state}, obj) => commit("saveFindParam", obj),
  clearFindParam:({commit, state}, obj) => commit("clearFindParam", obj),
  findCaseShareDetail:({commit, state}, obj) => commit("findCaseShareDetail", obj),
  clearViewPostCode:({commit, state}, obj) => commit("clearViewPostCode", obj),

}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/caseShareModule.js